module.exports = __webpack_public_path__ + "static/media/uranus-2.f98bbb18.jpg";